export default {
  Send: "bank/MsgSend",
  Stake: "cosmos-sdk/MsgDelegate",
  Unstake: "cosmos-sdk/MsgUndelegate",
  Redelegate: "cosmos-sdk/MsgBeginRedelegate",
  ClaimRewards: "cosmos-sdk/MsgWithdrawDelegationReward",
  Vote: "cosmos-sdk/MsgVote",
  Deposit: "cosmos-sdk/MsgDeposit",
  EnableAutoCompound: "cosmos-sdk/MsgGrant",
  DisableAutoCompound: "cosmos-sdk/MsgRevoke",
};
